// ResetPasswordModal.tsx
import { Modal, Typography, Button } from "antd";

interface ResetPasswordModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  userEmail: string;
  userName: string;
}

const ResetPasswordModal = ({
  visible,
  onCancel,
  onConfirm,
  userEmail,
  userName,
}: ResetPasswordModalProps) => {
  const { Text } = Typography;

  return (
    <Modal
      title="Reset Password"
      open={visible}
      onCancel={onCancel}
      aria-label="Reset Password Modal"
      footer={[
        <Button key="cancel" onClick={onCancel} aria-label="Cancel">
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={onConfirm} aria-label="Send Reset Link" loading={false}>
          Send Reset Link
        </Button>,
      ]}
    >
      <p style={{ color: "gray" }}>Send a password reset link to the user.</p>
      <p>
        Are you sure you want to send a password reset link to{" "}
        <Text strong>{userName}</Text> ({userEmail})?
      </p>
    </Modal>
  );
};

export default ResetPasswordModal;
